import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Container} from '../common/container'
import {Title} from '../common/title'
import {BackToSiteLink} from '../../common/back-to-site-link'
import s from './order-expired.scss'

export const OrderExpired = () => {
  const {t} = useTranslation()
  return (
    <Container dataHook={DH.ORDER_EXPIRED}>
      <div style={{textAlign: 'center'}}>
        <Title text={t('pageExpired')} />
        <BackToSiteLink className={s.link} />
      </div>
    </Container>
  )
}
